/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown> }} Ocr_Extracting_FramesInputs */

const en_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extracting frames... ${i?.progress}%`)
};

const fr_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extraction des images... ${i?.progress}%`)
};

const de_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frames werden extrahiert... ${i?.progress}%`)
};

const it_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estrazione dei fotogrammi... ${i?.progress}%`)
};

const ru_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Извлечение кадров... ${i?.progress}%`)
};

const es_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extrayendo fotogramas... ${i?.progress}%`)
};

const zh_cn2_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在提取帧... ${i?.progress}%`)
};

const ja_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フレームを抽出中... ${i?.progress}%`)
};

const hi_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ़्रेम निकाले जा रहे हैं... ${i?.progress}%`)
};

const pt_pt2_ocr_extracting_frames = /** @type {(inputs: Ocr_Extracting_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extraindo quadros... ${i?.progress}%`)
};

/**
* | output |
* | --- |
* | "Extracting frames... {progress}%" |
*
* @param {Ocr_Extracting_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_extracting_frames = /** @type {((inputs: Ocr_Extracting_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Extracting_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_extracting_frames(inputs)
	if (locale === "de") return de_ocr_extracting_frames(inputs)
	if (locale === "it") return it_ocr_extracting_frames(inputs)
	if (locale === "ru") return ru_ocr_extracting_frames(inputs)
	if (locale === "es") return es_ocr_extracting_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_extracting_frames(inputs)
	if (locale === "ja") return ja_ocr_extracting_frames(inputs)
	if (locale === "hi") return hi_ocr_extracting_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_extracting_frames(inputs)
	return en_ocr_extracting_frames(inputs)
});